module.exports = __webpack_public_path__ + "static/media/RO.f6c8771b.png";